import styled from '@emotion/styled';
import { Link } from 'gatsby';

export const MenuLink = styled(Link)`
  padding: 0 20px;
  &:last-child {
    padding-right: 0;
  }
`;

export const CartContainer = styled.div`
  width: 100%;
  height: 100vh;
  z-index: 1;
  @media (min-width: 768px) {
    max-width: 464px;
  }
`;
